import {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';

import Renderer from '../canvas/renderer'
import {multiAlign} from "../canvas/alignment";
import constants from "../constants";

export default @connect(reduce, actions)
class MultiAlignWidget extends Component {
  constructor() {
    super();

    this.multiAlignCenterHorizontal = () => {
      multiAlign(this.props.$elements, 'center-horizontal');
      this.props.updateElementAttribute('selectedMultiAligned', 'center-horizontal');
    };

    this.multiAlignCenterVertical = () => {
      multiAlign(this.props.$elements, 'center-vertical');
      this.props.updateElementAttribute('selectedMultiAligned', 'center-vertical');
    };

    this.multiAlignTop = () => {
      multiAlign(this.props.$elements, 'top');
      this.props.updateElementAttribute('selectedMultiAligned', 'top');
    };

    this.multiAlignRight = () => {
      multiAlign(this.props.$elements, 'right');
      this.props.updateElementAttribute('selectedMultiAligned', 'right');
    };

    this.multiAlignBottom = () => {
      multiAlign(this.props.$elements, 'bottom');
      this.props.updateElementAttribute('selectedMultiAligned', 'bottom');
    };

    this.multiAlignLeft = () => {
      multiAlign(this.props.$elements, 'left');
      this.props.updateElementAttribute('selectedMultiAligned', 'left');
    };

    this.distributeHorizontally = () => {
      Renderer.distribute(true, false);
    };

    this.distributeVertically = () => {
      Renderer.distribute(false, true);
    };
  }

  render(props, state) {
    return (
      <div className={props.alignRight ? 'dropdown right' : 'dropdown'}>
        <a className="dropdown-toggle icn rwd-icon" data-hint="Align">Align</a>
        <div className="dropdown-menu aligns" style={'right: 0;'}>
          <div className="angle left"/>
          <div className="align-header">{props.isMultiSelect ?   'Align Elements' : 'Align to Page'}</div>
          <ul>
            <li>
              <a
                className={props.selectedMultiAligned === 'left' ? 'selected' : ''}
                onClick={this.multiAlignLeft}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-left"}/>
                </svg>
                <span className="align-label">Left</span>
              </a>
            </li>
            <li>
              <a className={props.selectedMultiAligned === 'top' ? 'selected' : ''} onClick={this.multiAlignTop}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-top"}/>
                </svg>
                <span className="align-label">Top</span>
              </a>
            </li>
            <li>
              <a className={props.selectedMultiAligned === 'center-vertical' ? 'selected' : ''} onClick={this.multiAlignCenterVertical}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-vertical"}/>
                </svg>
                <span className="align-label">Center</span>
              </a>
            </li>
            <li>
              <a className={props.selectedMultiAligned === 'center-horizontal' ? 'selected' : ''} onClick={this.multiAlignCenterHorizontal}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-horizontal"}/>
                </svg>
                <span className="align-label">Middle</span>
              </a>
            </li>
            <li>
              <a className={props.selectedMultiAligned === 'right' ? 'selected' : ''} onClick={this.multiAlignRight}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-right"}/>
                </svg>
                <span className="align-label">Right</span>
              </a>
            </li>
            <li>
              <a className={props.selectedMultiAligned === 'bottom' ? 'selected' : ''} onClick={this.multiAlignBottom}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-bottom"}/>
                </svg>
                <span className="align-label">Bottom</span>
              </a>
            </li>
          </ul>
          <div className={'align-header distribute' + (props.isMultiSelect ? '' : ' hidden')}>Distribute Elements</div>
          <ul className={props.isMultiSelect ? '' : 'hidden'}>
            <li>
              <a onClick={this.distributeHorizontally}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-enter-horizontal"}/>
                </svg>
                <span className="align-label">Horizontally</span>
              </a>
            </li>

            <li>
              <a onClick={this.distributeVertically}>
                <svg className="icn rotate-90" style="margin: 0; position: relative; top: -.5px;">
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-enter-horizontal"}/>
                </svg>
                <span className="align-label">Vertically</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  };
};
